import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  NativeSelect,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { memo, useEffect, useState } from "react";
import configServ from "../../services/config";
import CheckAndReturn from "../../utility/CheckAndReturn";
import {
  cellStyle,
  evenRowStyle,
  headerCellStyle,
  oddRowStyle,
  rowStyle,
} from "../../utility/CustomStyle";
import {
  Cancel,
  CheckCircle,
  Close,
  DisabledByDefault,
  Reply,
  VisibilityTwoTone,
} from "@mui/icons-material";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import SearchBox from "../Search/SearchBox";
import CreatePrescription from "../prescription/CreatePrescription";
import { useDispatch, useSelector } from "react-redux";
import { rSetResponse } from "../../redux/reducers/GlobalVariables";

// FUNCTION
const AllEnquiries = ({ open, handleClose }) => {
  //#region code
  const dispatch = useDispatch();
  const { company_id, enquiry_id, customer } = useSelector(
    (state) => state.GlobalVariables
  );
  const rowsPerPageOptions = [10, 20, 50];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(rowsPerPageOptions[0]);
  const [enquiries, setEnquiries] = useState([]);
  const [filterEnquiries, setFilterEnquiries] = useState([]);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [searchBy, setSearchBy] = useState("item_name");
  const [search, setSearch] = useState(null);
  const [openPrescription, setOpenPrescription] = useState(false);
  const [prescriptionData, setPrescriptionData] = useState(null);

  const headers = [
    { label: "Pain Area", value: "item_name" },
    { label: "Date", value: "submitted_at" },
    { label: "Status", value: "status" },
  ];

  const fetchQuestionnaireResponsesByUserId = async () => {
    try {
      setLoading(true);
      const dataToSend = {
        user_id: enquiry_id,
      };
      const res = await configServ.getQuestionnaireResponsesByUserId(
        dataToSend
      );
      if (res.status === 200) {
        setEnquiries(res.data);
        setFilterEnquiries(res.data);
        setCount(res.data.length);
      } else {
        setEnquiries([]);
        setFilterEnquiries([]);
        setCount(0);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (enquiry_id !== null) {
      fetchQuestionnaireResponsesByUserId();
    }
  }, [enquiry_id]);

  useEffect(() => {
    if (search !== null) {
      const data = enquiries.filter((x) =>
        x.item_name.toLowerCase().includes(search.toLowerCase())
      );
      setFilterEnquiries(data);
      setCount(data.length);
    } else {
      setFilterEnquiries(enquiries);
      setCount(enquiries.length);
    }
  }, [search]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearchBy = (event) => {
    try {
      setSearchBy(event.target.value);
    } catch (error) {
      console.log(error);
    }
  };

  const handleCloseEnquiry = () => {
    handleReset();
    handleClose();
  };

  const handleReset = () => {
    setPage(0);
    setRowsPerPage(rowsPerPageOptions[0]);
    setSearch(null);
    setEnquiries([]);
    setFilterEnquiries([]);
  };

  const handleClosePrescription = () => {
    setOpenPrescription(false);
    setPrescriptionData(null);
    dispatch(rSetResponse(null));
  };

  const handlePrescription = (params) => {
    try {
      setPrescriptionData(params);
      dispatch(rSetResponse(params.response_id));
      setOpenPrescription(true);
    } catch (e) {
      console.log(e);
    }
  };

  //#endregion

  return (
    <>
      <CreatePrescription
        open={openPrescription}
        handleClosePrescription={handleClosePrescription}
        prescriptionData={prescriptionData}
      />

      <Dialog
        open={open}
        onClose={handleCloseEnquiry}
        scroll="paper"
        disableEscapeKeyDown
        disableBackdropClick
        fullWidth
        maxWidth="lg"
      >
        <DialogContent>
          <Box
            display={"flex"}
            flexDirection={"row"}
            justifyContent={"space-between"}
          >
            <IconButton onClick={handleCloseEnquiry} title="BACK">
              <Reply color="primary" sx={{ fontSize: 40 }} />
            </IconButton>
            <Typography variant="h5" color={"#1e61b4"} fontWeight={"bold"}>
              All Enquiries By {customer || ""}
            </Typography>
            <IconButton onClick={handleCloseEnquiry} title="CLOSE">
              <DisabledByDefault color="error" sx={{ fontSize: 40 }} />
            </IconButton>
          </Box>

          <Box width={"100%"} px={5}>
            <Grid
              container
              alignItems="flex-end"
              justifyContent="flex-start"
              spacing={1}
            >
              <Grid container item xs={12} md={6} justifyContent={"flex-start"}>
                <Typography sx={{ fontSize: "18px", fontWeight: "bold" }}>
                  Enquiries: {count}
                </Typography>
              </Grid>
              <Grid item xs={12} md={3}>
                <Box sx={{ minWidth: 120 }}>
                  <FormControl fullWidth>
                    <InputLabel
                      variant="standard"
                      htmlFor="uncontrolled-native"
                    >
                      Search By
                    </InputLabel>
                    <NativeSelect
                      value={searchBy}
                      onChange={handleSearchBy}
                      inputProps={{
                        name: "searchBy",
                        id: "uncontrolled-native",
                      }}
                    >
                      <option value={"item_name"}>Name</option>
                    </NativeSelect>
                  </FormControl>
                </Box>
              </Grid>
              <Grid item xs={12} md={3}>
                <SearchBox search={search} setSearch={setSearch} />
              </Grid>
            </Grid>

            <TableContainer sx={{ mt: 1 }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell sx={headerCellStyle}>S.No.</TableCell>
                    {headers.map((column, index) => (
                      <TableCell key={index} sx={headerCellStyle}>
                        {column.label}
                      </TableCell>
                    ))}
                    <TableCell sx={headerCellStyle}>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading === false ? (
                    filterEnquiries.length > 0 ? (
                      filterEnquiries
                        .slice(page * rowsPerPage, (page + 1) * rowsPerPage)
                        .map((row, rowIndex) => (
                          <TableRow
                            key={rowIndex}
                            sx={{
                              ...rowStyle,
                              ...(rowIndex % 2 === 0
                                ? evenRowStyle
                                : oddRowStyle),
                            }}
                          >
                            <TableCell sx={cellStyle}>
                              <Typography variant="body1">
                                {page * rowsPerPage + rowIndex + 1}
                              </Typography>
                            </TableCell>
                            <TableCell sx={cellStyle}>
                              {row.item_name}
                            </TableCell>
                            <TableCell sx={cellStyle}>
                              {CheckAndReturn.transformToDate3(
                                row.submitted_at
                              )}
                            </TableCell>
                            <TableCell sx={cellStyle}>
                              {Boolean(row.status) === true ? (
                                <Typography
                                  variant="caption"
                                  fontWeight={"bold"}
                                  color={"green"}
                                >
                                  Open
                                </Typography>
                              ) : (
                                <Typography
                                  variant="caption"
                                  fontWeight={"bold"}
                                  color={"red"}
                                >
                                  Close
                                </Typography>
                              )}
                            </TableCell>
                            <TableCell sx={cellStyle}>
                              <Stack direction={"row"}>
                                <Tooltip title="Precription" placement="top">
                                  <IconButton
                                    disabled={!Boolean(row.status)}
                                    sx={{ cursor: "pointer" }}
                                    onClick={() => handlePrescription(row)}
                                  >
                                    <BorderColorIcon
                                      color={
                                        Boolean(row.status) === true
                                          ? "primary"
                                          : "disabled"
                                      }
                                      sx={{ cursor: "pointer" }}
                                    />
                                  </IconButton>
                                </Tooltip>
                                {/* <Tooltip title="Symptoms" placement="top">
                                                                <IconButton sx={{ cursor: "pointer" }}>
                                                                    <VisibilityTwoTone
                                                                        color='info'
                                                                        sx={{ cursor: "pointer" }}
                                                                    />
                                                                </IconButton>
                                                            </Tooltip> */}
                              </Stack>
                            </TableCell>
                          </TableRow>
                        ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={12}>
                          <Box textAlign={"center"}>
                            <Typography variant="body1" color={"red"}>
                              No data found.
                            </Typography>
                          </Box>
                        </TableCell>
                      </TableRow>
                    )
                  ) : (
                    <TableRow>
                      <TableCell colSpan={12} sx={{ textAlign: "center" }}>
                        <Box>
                          <CircularProgress />
                        </Box>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={rowsPerPageOptions}
              component="div"
              count={count}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              sx={{
                mt: "auto", // Ensure the pagination stays at the bottom
              }}
            />
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default memo(AllEnquiries);
